import React from 'react';
import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const EllipsisCellRenderer = ({ value }) => (
  <div className="form-action-btn-group"><span className="text-ellipsis" title={ `"${ value }"` }>{ value || 'N/A' }</span></div>
);

EllipsisCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};

EllipsisCellRenderer.defaultProps = {
  value: 'N/A'
};
